(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["moise-channel"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ChannelIO || window.Shopify?.designMode) return;
  const channel = function () { channel.c(arguments); };
  channel.q = [];
  channel.c = function (args) { channel.q.push(args); };
  window.ChannelIO = channel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
  document.head.appendChild(script);
  const language = document.documentElement.lang.split('-')[0];
  const uiLanguage = ['ko','en','ja'].includes(language) ? language : 'en';
  let bootFailed = false;
  let ready = false;
  let openRequested = false;
  document.querySelector('[data-moise-chat-link]')?.addEventListener('click', event => {
    if (bootFailed) return;
    event.preventDefault();
    openRequested = true;
    if (ready) window.ChannelIO('showMessenger');
  });
  channel('boot',{pluginKey:'3503b922-0519-4393-a01d-79aa3b4c5da8',language:uiLanguage,mobileMessengerMode:'iframe',hidePopup:true,hideChannelButtonOnBoot:true,zIndex:9999},error=>{
    if (error) { bootFailed = true; console.warn('MOISĒ chat is temporarily unavailable.'); return; }
    ready = true;
    window.ChannelIO('updateUser', { language: uiLanguage });
    if (openRequested) window.ChannelIO('showMessenger');
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moise-imported-reviews"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const button = event.target.closest('[data-mr-more]');
  if (!button) return;
  const root = button.closest('.mr-reviews');
  Array.from(root.querySelectorAll('[data-mr-extra][hidden]')).slice(0,6).forEach(el => { el.hidden = false; });
  if (!root.querySelector('[data-mr-extra][hidden]')) button.hidden = true;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moise-join-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  document.querySelectorAll('.moise-join-menu[open]').forEach(menu=>{
    if(!menu.contains(event.target)||event.target.closest('[data-me-open]'))menu.open=false;
  });
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.moise-join-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["moise-region-control"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
  document.querySelectorAll('.mc-localization details[open]').forEach(details=>{if(!details.contains(event.target))details.open=false;});
});
document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  document.querySelectorAll('.mc-localization details[open]').forEach(details=>{details.open=false;details.querySelector('summary').focus();});
});
  } catch(e) { console.error(e); }
})();

})();
